
<template>
    <div>
        <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
            <v-card-title style="padding-bottom:0">
                <span class="page-title">Registration</span>
            </v-card-title>
            <span>Must login to register</span>
        </v-card>

        <v-card class="main-card" v-if="$AuthSvc.isLogin() && scoreCard !== null">
            <v-card-text v-if="tournament!==null && tournament.status !== 'REGISTER'">
              <span class="label14">No tournaments to register at this time</span>
            </v-card-text>
            <v-card-text v-if="tournament!==null && tournament.status === 'REGISTER'">
                <span class="label18">Congratulations!</span><br/><br/>
                <span class="label14">You have registered for {{tournament.course.name}}.</span>
                <span v-if="scoreCard.owe > 0">
                    <br>
                    You still owe the amount of ${{scoreCard.owe}}.<br>
                    <span v-if="scoreCard.paymentType!=='Complimentary'">
                        You preferred to pay by {{scoreCard.paymentType}}.
                    </span>
                    <span v-if="scoreCard.paymentType==='Complimentary'">
                        Your payment selection is Complimentary and requires an approval.
                    </span>
                    <br>
                </span>

                <span v-if="!isBanquet() && scoreCard.paymentType==='Complimentary'">
                    <br/>
                    PLEASE BE AWARE: <br>
                    If you choose "Complimentary", the OKAGA President/Treasurer will review your
                    enrollment and MUST approve your complement fee before the deadlline.<br/>
                    Please contact Robert Gay at (405) 641-7051 if you have any questions.
                    <br>
                </span>
                <span v-if="scoreCard.paymentType==='Zelle' && tournament.formatType==='TOURNAMENT' && scoreCard.owe > 0">
                    <br/>
                        Please send ZELLE payment to <b>@Deans-Le</b> before the tournament deadline.
                    <br/>
                </span>
                <span v-if="scoreCard.paymentType==='Paypal' && tournament.formatType==='TOURNAMENT' && scoreCard.owe > 0">
                    <br/>
                        Please send PayPal payment to <b>@DeansOKAGA</b> before the tournament deadline.
                    <br/>
                </span>
                <span v-if="scoreCard.paymentType==='Venmo' && tournament.formatType==='TOURNAMENT' && scoreCard.owe > 0">
                    <br/>
                        Please send Venmo payment to <b>@Deans-Le</b> before the tournament deadline.
                    <br/>
                </span>

                <br>

                <span v-if="scoreCard.owe > 0">
                    You must pay your dues by {{printDate(tournament.earlyRegisterDeadline)}} to qualify for Early Member Fee.
                    <br> <br>
                    All dues MUST BE PAID before the deadline {{printDateTime(tournament.registrationDeadline)}}
                    in order to participate in the tournament, otherwise your registration will be CANCELLED and awarded to
                    standby's.
                    <br>
                </span>
                <span class="label14" v-if="scoreCard.owe === 0 && !isBanquet()">
                    <br>
                    See you at the golf course!
                </span>
                <span class="label14" v-if="scoreCard.owe === 0 && isBanquet()">
                    <br>
                    See you at the party!
                </span>
            </v-card-text>
        </v-card>

        <v-card class="main-card" v-if="$AuthSvc.isLogin() && scoreCard === null && tournament !== null">
            <v-card style="padding: 20px" class="mx-auto mt-5">
                <v-card-title>
                    <h2 style="color:darkgreen;">Registration</h2>
                </v-card-title>
                <br>

                <v-card style="padding: 10px;margin-bottom: 20px;">
                    <v-card-text v-if="tournament!==null">
                        <span class="label14">Course: </span> {{tournament.course.name}} <br/>
                        <span class="label14">Schedule Date: </span> {{printDateTime(tournament.scheduleDate)}} <br/><br/>

                        <span class="label14">Name: </span> {{$AuthSvc.getFullName()}} <br/>
                        <span class="label14">Email: </span> {{$AuthSvc.getUserInfo().email}} <br/>
                        <span class="label14">Flight: </span> {{getFlight($AuthSvc.getUserInfo().flight)}} <br/>
                        <span class="label14">Member Status: </span> {{$AuthSvc.getUserInfo().status}}<br/>
                        
                        <div>
                            <span class="label16">Guest Fee: </span>
                            <span>${{tournament.guestFee}}</span> &nbsp; &nbsp;
                        </div>
                    </v-card-text>
                </v-card>

                <v-card-text>
                    <br/><br/>
                    <v-form>
                        <v-card-label style="margin-top: 30px" v-if="!isBanquet()">Special Request</v-card-label>
                        <v-container fluid v-if="!isBanquet()">
                            <v-text-field v-model="specialRequest">Enter request</v-text-field>
                        </v-container>

                        <v-card-label style="margin-top: 30px">Payment Selection</v-card-label>

                        <v-container fluid
                                     v-if="tournament!==null && tournament.formatType==='TOURNAMENT'">
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="paymentType" @change="onChange()"
                                              :items="paymentTypeSelections"
                                              label="Payment Type"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>

                        <span class="label14">Fee: ${{fee}}</span>
                        <div v-if="!isBanquet() && tournament.formatType==='TOURNAMENT'">
                            <br v-if="membershipFeeCost">
                            <span class="label14" v-if="membershipFeeCost">Membership Fee: ${{membershipFeeCost}}</span>
                        </div>
                        <br><br>
                        <span class="label16">Total Fee: ${{totalFee}} </span>
                    </v-form>
                </v-card-text>
                <v-card-actions class="actions-card">
                    <v-btn style="background-color:darkgreen;color:white;" @click="formSubmit()">Register</v-btn>
                </v-card-actions>
            </v-card>

        </v-card>

    </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      JUNIOR_FEE: 80,
      membershipFeeCost: 0,
      membershipSelection: 'Not at this time',
      memberFee: 0,
      fee: 0,
      lateFee: 0,
      hioFee: 0,
      totalFee: 0,
      totalPlayers: 0,
      owe: 0,
      paymentType: 'Zelle',
      raffle: 0,
      holeInOne: "Not Interested",
      guestSelection: "0 - No Guest",
      birdieHunt: "No",
      birdieHuntFee: 0,
      tournament: null,
      userInfo: null,
      scoreCard: null,
      specialRequest: '',
      banquetGuests: [],
      totalGuests: 0,
      membershipSelections: [
        "Join as 2025 Member Now",
        "Not at this time"
      ],
      paymentTypeSelections: [
        "Zelle",
        "PayPal",
        "Venmo",
        "Complimentary"
      ],
      paymentTypeSelections2: [
        "Zelle",
        "Complimentary"
      ],
      funPaymentTypeSelections: [
        "Zelle",
        "Settle at course"
      ],
      holeInOneSelections: [
        "$5",
        "Not Interested"
      ],
      birdieHuntSelection: [
        "No",
        "Yes"
      ],
      numGuestSelections: [
        "0 - No Guest",
        "1 - Guest",
        "2 - Guests",
        "3 - Guests",
        "4 - Guests",
        "5 - Guests",
        "6 - Guests",
        "7 - Guests"
      ]
    }),
    mounted: function () {
        var _this = this;
        _this.userInfo = this.$AuthSvc.getUserInfo();

        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id')
        if (id !== null && id !== '') {
          _this.$CommandSvc.get(_this, '/public/tournament-course/' + id, function(data) {
            if (data !== null) {
              _this.tournament = data.tournament;
              _this.tournament.course = data.course;
              window.sessionStorage.setItem('selectTournament', JSON.stringify(_this.tournament));
              _this.loadScoreCard();
            }
          });
        }
        else {
            var t = window.sessionStorage.getItem('selectTournament');
            if (t === null) {
                _this.$CommandSvc.get(_this, '/public/tournaments/status/REGISTER', function (data) {
                    if (data.length === 1) {
                        _this.tournament = data[0].tournament;
                        _this.tournament.course = data[0].course;
                        window.sessionStorage.setItem('selectTournament', JSON.stringify(_this.tournament));
                        _this.loadScoreCard();
                    }
                });
            } else {
                _this.tournament = JSON.parse(t);
                _this.loadScoreCard();
            }
        }
    },
    methods: {
      printDateTime(date) {
          return moment(date).format('MMMM Do hh:mm A');
      },
      printDate(date) {
          return moment(date).format('MMM Do');
      },
      isBanquet() {
          if (this.tournament !== null) {
              return (this.tournament.tournamentId === 33);
          }

          return false;
      },
      isEarly(ts) {
        var now = moment();
        return now.isBefore(ts)
      },
      invoice() {
        if (this.$AuthSvc.isFw() && ['FUN_FW', 'FUN_FW_TEAM'].includes(this.tournament.formatType)) {
            console.log("Firewheel crew");
        }
        else {
          window.location.href = '/registration-invoice';
        }
      },
      loadScoreCard() {
          var _this = this;

          this.totalGuests = 0;
          this.JUNIOR_FEE = this.tournament.juniorFee==='' ? 80 : Number(this.tournament.juniorFee);

          if (_this.userInfo !== null && _this.tournament !== null) {
              var url = '/public/scores/players/' + _this.tournament.tournamentId + '/' + _this.userInfo.playerId;
              console.log("URL: " + url);
              this.axios.get(url)
                  .then(function (response) {
                      if (response.data !== null && response.data !== "") {
                          _this.scoreCard = response.data;

                          if (_this.isBanquet()) {
                              _this.fee = 0;

                              if (!_this.$AuthSvc.isMember()) {
                                  _this.fee = _this.tournament.guestFee;
                              }

                              _this.totalFee = _this.fee;
                          }

                      }
                      _this.onChange();
                  })
                  .catch(function (error) {
                      console.log('ERROR: ' + error);
                  });

              this.axios.get('/public/scores/players/' + _this.tournament.tournamentId + '/count')
                  .then(function (response) {
                      _this.totalPlayers = response.data;
                      if (_this.totalPlayers >= _this.tournament.limitSize) {
                          _this.paymentType = 'StandBy';
                      }
                  })
                  .catch(function (error) {
                      console.log('ERROR: ' + error);
                  });
          }
      },
      onGuestChange() {
        this.fee = 0;
        if (!this.$AuthSvc.isMember()) {
            this.fee = Number(this.tournament.guestFee);
        }

        this.banquetGuests = [];
        var numGuests = this.guestSelection.substr(0,1);

        if (numGuests > 0 ) {
            if (!this.$AuthSvc.isMember()) {
                this.fee = this.fee + (numGuests * this.tournament.guestFee);
            }
            else {
                this.fee = this.fee + ((numGuests-1) * this.tournament.guestFee);
            }
        }

        this.totalFee = this.fee;

        for(var i=0; i < numGuests; i++) {
            this.banquetGuests.push('');
        }
      },
      onChange() {
        this.lateFee = 0;

        if (this.$AuthSvc.getUserInfo().status === 'NON-MEMBER') {
            if (this.membershipSelection === 'Join as 2025 Member Now') {
              this.memberFee = Number(this.tournament.memberFee);

              this.fee = this.memberFee;
              this.totalFee = this.fee;

              var now = moment();
              if (now.isAfter(this.tournament.earlyRegisterDeadline)) {
                this.lateFee = 10;
              }

              if (this.$AuthSvc.isJunior() || this.$AuthSvc.isSenior()) {
                this.membershipFeeCost = 60;
              }
              else {
                this.membershipFeeCost = 120;
              }

              if (this.$AuthSvc.isJunior() ) {
                this.memberFee = this.JUNIOR_FEE;
                this.lateFee = 0
              }
            }
            else {
              this.memberFee = Number(this.tournament.guestFee);
              this.membershipFeeCost = 0;
            }
        }
        else {
          if (this.$AuthSvc.isMember()) {

              this.memberFee = Number(this.tournament.memberFee);

              this.fee = this.memberFee;
              this.totalFee = this.fee;

              var now = moment();
              if (now.isAfter(this.tournament.earlyRegisterDeadline)) {
                if (!this.$AuthSvc.isJunior()) {
                  this.lateFee = 10;
                }
              }

              if (this.$AuthSvc.isJunior() ) {
                this.memberFee = this.JUNIOR_FEE;
                this.lateFee = 0
              }
          }
          else {
            this.memberFee = Number(this.tournament.guestFee);
            this.fee = this.memberFee;
            this.lateFee = 0
          }
        }

        this.memberFee += this.lateFee;
        this.fee = this.memberFee;
        this.totalFee = this.fee;

        if (this.holeInOne === '$5') {
          this.hioFee = 5;
        }
        else {
          this.hioFee = 0;
        }

        if (this.birdieHunt === 'Yes') {
            this.birdieHuntFee = 10;
        }
        else {
            this.birdieHuntFee = 0;
        }

        this.totalFee = this.fee;
      },
      getFlight(flight) {
        if (flight === "Nicklaus") {
            return "Nicklaus (≤0-7.99)";
        } else if (flight === "Palmer") {
            return "Palmer (8-15.99)";
        } else if (flight === "Hogan") {
            "Hogan (16-30+)";
        } else if (flight === "Women") {
            return "Women";
        } else {
            return "Unknown";
        }
      },
      addFee(addFee) {
        this.fee += addFee;
      },
      formSubmit() {
          var _this = this;

          var totalBanquetFee = 0;
          if (_this.isBanquet()) {
            this.specialRequest = '';

            if (!this.$AuthSvc.isMember()) {
                totalBanquetFee += Number(_this.tournament.guestFee);
            }

            for(var i=0; i < this.banquetGuests.length; i++) {
              var fee =  '$' + _this.tournament.guestFee;;
              if (this.$AuthSvc.isMember() && i === 0) {
                fee = 'FREE';
              } else {
                totalBanquetFee += Number(_this.tournament.guestFee);
              }

              this.banquetGuests[i] = "(" + (i+1) + ") " + this.banquetGuests[i] + " - " + fee;
              this.specialRequest =  this.banquetGuests.join(", ");
            }

            this.fee = totalBanquetFee;
            this.totalFee = totalBanquetFee;
          }

          var userInfo = this.$AuthSvc.getUserInfo();
          var scoreCard = {
            playerId: userInfo.playerId,
            tournamentId: this.tournament.tournamentId,
            flight: userInfo.flight,
            isOfficial: false,
            isRegister: true,
            fee: this.fee,
            lateFee: this.lateFee,
            raffle: this.banquetGuests.length + 1,
            memberFee: this.membershipFeeCost,
            holeInOne: this.hioFee,
            birdieHunt: this.birdieHunt,
            owe: this.totalFee,
            paymentType: this.paymentType,
            specialRequest: this.specialRequest,
            member: this.$AuthSvc.isMember()?'Y':'N'
          };

          this.axios.post('/api/tournaments/registration', scoreCard)
          .then(function (response) {
              _this.scoreCard = response.data;

              var scoreCardData = JSON.stringify(response.data);
              window.sessionStorage.setItem('score-card', scoreCardData);
          })
          .catch(function (error) {
              swal("Error", "Registration failed.", "error");
              console.log('ERROR: ' + error);
          });
      },
    }
  }
</script>

<style scoped>
    * {
        font-size: 14px;
    }

    .v-list-item__title {
        font-size: 16px !important;
    }

    .v-list-item {
        border-bottom: 1px solid black !important;
    }
  .v-card {
    background-color: #e6f2ea;
  }

  .v-checkbox, .v-input {
    margin: 0;
    padding: 0;
  }

  .login {
    margin-top: 12px;
    width: 100%;
  }

  .actions-card {
    margin-top: 20px;
  }

  @media (min-width: 768px) {

  }

</style>